var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 3H13V14H4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E13333",
    d: "M14.513 2.487c-3.316-3.315-8.71-3.315-12.027 0-3.315 3.316-3.315 8.711 0 12.027C4.145 16.172 6.322 17 8.5 17c2.178 0 4.355-.828 6.013-2.486 3.316-3.316 3.316-8.71 0-12.027zm-2.506 8.52c.277.276.277.724 0 1.001-.138.139-.32.208-.5.208-.182 0-.364-.07-.502-.208L8.5 9.502l-2.504 2.506c-.14.138-.32.207-.501.207-.182 0-.363-.07-.501-.207-.278-.277-.278-.726 0-1.002L7.498 8.5 4.993 5.995c-.277-.277-.277-.725 0-1.002.276-.277.725-.277 1.002 0L8.5 7.498l2.505-2.505c.277-.277.725-.277 1.002 0s.277.725 0 1.002L9.502 8.5l2.505 2.506z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H17V17H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.8dbcdcb91836bd6d3c0262f2bddee5a1.svg";
export { ForwardRef as ReactComponent };